import { useState } from 'react'

const tabs = [
  { label: 'Dashboard', slug: 'dashboard', screenshot: 'website1.png' },
  { label: 'Portfolio', slug: 'portfolio-overview', screenshot: 'website2.png' },
  { label: 'Calendar', slug: 'dividend-calendar', screenshot: 'website3.png' },
  { label: 'Options', slug: 'options-tracker', screenshot: 'website4.png' },
  { label: 'Reports', slug: 'income-reports', screenshot: 'website5.png' },
]

export default function DashboardMockup() {
  const [activeTab, setActiveTab] = useState(0)
  const tab = tabs[activeTab]

  return (
    <div className="w-full">
      {/* Tab Navigation */}
      <div className="flex flex-wrap justify-center gap-2 mb-8">
        {tabs.map((t, i) => (
          <button
            key={t.label}
            onClick={() => setActiveTab(i)}
            className={`px-4 py-2 text-sm rounded-full border transition-all duration-300 ${
              activeTab === i
                ? 'bg-[#1B5E20] text-white border-[#1B5E20]'
                : 'bg-transparent text-[#475569] border-[#E2E8F0] hover:border-[#1B5E20] hover:text-[#1B5E20]'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Mockup Frame */}
      <div className="mx-auto max-w-4xl">
        <div className="bg-[#E2E8F0] rounded-xl overflow-hidden shadow-dashboard">
          {/* Browser Bar */}
          <div className="bg-[#F1F5F9] px-4 py-2.5 flex items-center gap-2 border-b border-[#E2E8F0]">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-[#EF4444]" />
              <div className="w-3 h-3 rounded-full bg-[#F59E0B]" />
              <div className="w-3 h-3 rounded-full bg-[#22C55E]" />
            </div>
            <div className="flex-1 bg-white rounded-md px-3 py-1 text-xs text-[#94A3B8] border border-[#E2E8F0]">
              safedividendtracker.com/{tab.slug}
            </div>
          </div>
          {/* Real Screenshot */}
          <img
            src={`/screenshots/${tab.screenshot}`}
            alt={tab.label}
            className="w-full block"
            style={{ minHeight: '400px', objectFit: 'cover', objectPosition: 'top' }}
          />
        </div>
      </div>
    </div>
  )
}
